import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { string } from 'prop-types';
import SvgIcon from '../SvgIcon';
export default function createSvgIcon(childPath, displayName, defaults = {}) {
  const Component = /*#__PURE__*/React.memo(props => {
    const propsWith = Object.assign({}, defaults, props, {
      fill: props.fill || props.color || defaults.fill || defaults.color,
      color: props.color || props.fill || defaults.color || defaults.fill,
      viewBox: props.viewBox || defaults.viewBox || '0 0 24 24'
    });
    return /*#__PURE__*/React.createElement(SvgIcon, _extends({
      "data-testid": `${displayName}Icon`
    }, propsWith), childPath);
  });
  process.env.NODE_ENV !== "production" ? Component.propTypes = {
    color: string,
    fill: string,
    viewBox: string
  } : void 0;
  Component.defaultProps = {
    color: null,
    fill: null,
    viewBox: null
  };
  Component.name = `${displayName}Icon`;
  Component.displayName = Component.name;
  Component.path = childPath;
  Component.viewBox = defaults.viewBox;
  return Component;
}